import React from 'react';
import {UtmTable} from '@components/orders/modals/new-order/components/utm-table.component';
import {ClientPhoneAutocomplete} from '@components/form/ClientPhoneAutocomplete';
import {StandartInput} from '@components/form/StandartInput';
import {Select} from '@components/form/Select';
import {deliveryTypes as NovaposhtaDeliveryTypes} from '@components/modules/novaposhta/modals/new-ttn/enum/constants';
import {Helmet} from "react-helmet";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import RemoteAutocompleteSelect from '@components/form/RemoteAutocompleteSelect';
import RemoteAutocompleteWithSearch from '@components/form/RemoteAutocompleteWithSearch';
import ResponsiveComponent from '@components/form/ResponsiveComponent';
import {SimpleDialog} from "@components/form/SimpleDialog";
import {MaterialTableComponent} from "@components/form/MaterialTableComponent";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import {AddProductModal} from '@components/orders/modals/new-order/components/modals/add-product.component';
import IconButton from "@material-ui/core/IconButton";
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import {InputBarcode} from '@components/form/InputBarcode';
import InputAdornment from "@material-ui/core/InputAdornment";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import AddCircleRoundedIcon from "@material-ui/icons/AddCircleRounded";
import {LabelButton} from "@components/common/buttons/LabelButton";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {orderFieldsTypes} from '@components/pipeline/constants/index';
import {TooltipButton} from "@components/common/buttons/TooltipButton";
import Tooltip from "@material-ui/core/Tooltip";
const merge = require('deepmerge');
import clsx from 'clsx';
import {Input} from "@components/form/Input";
import {deliveryTypes as UkrposhtaDeliveryTypes} from "@components/modules/ukrposhta/modals/new-ttn/enum/constants";
import {PermissionModule} from "@components/common/permission/PermissionModule";

export class NewOrderComponent extends React.Component {
    initState = {
        form: {
            price_group_id: 0,
            client_id: null,
            currency: {
                id: 0,
                code: "",
                rate: 0,
            },
            currency_id: 0,
            currency_course: 0,
            name: "",
            phone: this.props.phone || "",
            email: "",
            comment: this.props.comment || "",
            payment_type: "cod",
            amount_prepaid: "",
            ttn: "",
            ttn_type: "novaposhta",
            dropshipper_id: "",
            user_id: "",
            delivery_details_novaposhta: {
                ServiceType: this.props.ServiceType || NovaposhtaDeliveryTypes[0].value,
                CityRecipient: '',
                CityRecipientName: '',
                RecipientAddress: '',
                RecipientAddressName: '',
                Description: '',
                Weight: '',
            },
            delivery_details_ukrposhta: {
                deliveryType: UkrposhtaDeliveryTypes[0].value,
                recipient_postcode: '',
                recipient_address: '',
                description: '',
            },
            utm: {
                website: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_term: '',
                utm_content: '',
            },
            products: [],
            pipeline_id: null,
            pipeline_fields: {},
        },
        errors: {},
        barcode: {1: "", 0: ""},
        novaposhtaConfig: {
            api_key: ''
        },
        isMarketingPanelOpen: false,
    };
    state = {
        open: false,
        ...this.initState
    }

    async componentDidUpdate(prevState, prevProps) {
        if (this.state.open && this.state.open != prevProps.open) {
            let form = {}

            if (this.props.orderId) {
                const data = await this.props.getOrderDetails(this.props.orderId);
                form = data.data;
                if (!form.currency || !form.price_group_id) {
                    const defaultData = await this.props.getDefaultOrderData();
                    form.price_group_id = defaultData.price_group_id;
                    form.currency_id = defaultData.currency.id;
                    form.currency_course = defaultData.currency.rate;
                    form.currency = defaultData.currency;
                }
                if (data.data.pipeline_id) {
                    let pipeline_fields = {};
                    data.data.pipeline_fields.forEach(field => {
                        pipeline_fields[field.pipeline_field_id] = field.value;
                    });
                    form = {...form, pipeline_fields: pipeline_fields}
                }
            } else {
                const defaultData = await this.props.getDefaultOrderData();
                form = {...form,
                    price_group_id: defaultData.price_group_id,
                    currency_id: defaultData.currency.id,
                    currency_course: defaultData.currency.rate,
                    currency: defaultData.currency,
                }
            }
            let novaposhtaConfig = await this.props.getNovaposhtaModuleConfiguration();
            this.setState({
                ...this.initState,
                form: merge(this.state.form, form),
                novaposhtaConfig: {
                    api_key: novaposhtaConfig.data.cabinets[0] ? novaposhtaConfig.data.cabinets[0].api_key : ''
                }
            }, () => {
                if (this.props.client) {
                    this.clientSelected(this.props.client);
                }
            });
        } else if (this.state.open != prevProps.open) {
            this.setState(this.initState)
        }
    }

    addProduct = (variationProduct, amount, is_main) => {
        let variationInOrder = this.state.form.products.filter(row => {
            return row.variation_id === variationProduct.id && row.is_main === is_main;
        });
        if (variationInOrder.length > 0) {
            this.setProductAmount(variationInOrder[0].variation_id, variationInOrder[0].amount + 1, 1)
        } else {
            let orderProduct = {
                type: 'product',
                variation_id: variationProduct.id,
                main_price: variationProduct.price,
                original_price: variationProduct.price,
                price_in: variationProduct.price_in,
                prices: variationProduct.prices,
                amount: amount,
                original_sum: variationProduct.price * amount,
                comment: variationProduct.comment,
                variation: variationProduct,
                is_main: is_main
            };
            this.setState({
                form: merge(this.state.form, {products: [orderProduct]}),
                errors: {
                    ...this.state.errors,
                    products: undefined
                }});
        }
    };

    updateProduct = (variationProduct, amount, is_main) => {
        let { products } = this.state.form;

        let orderProduct = {
            type: 'product',
            variation_id: variationProduct.id,
            original_price: variationProduct.price,
            price_in: variationProduct.price_in,
            amount: amount,
            original_sum: variationProduct.price * amount,
            comment: variationProduct.comment,
            variation: variationProduct,
            is_main: is_main
        };

        products = products.map(row =>
            row.variation_id === variationProduct.id && row.is_main === is_main
                ? orderProduct
                : row
        );

        this.setState({
            form: {...this.state.form, products: products},
            errors: {
                ...this.state.errors,
                products: undefined
            }});
    }

    removeProduct = (variationId, is_main) => {
        this.setState({
            form: {
                ...this.state.form,
                products: this.state.form.products.filter(row => {
                    if (row.variation_id === variationId && row.is_main === is_main) {
                        return false;
                    }
                    return row;
                })
            }
        })
    };

    setProductAmount = (variationProduct, amount, is_main) => {
        const products = this.state.form.products.map(row => {
            if (row.variation_id === variationProduct && row.is_main === is_main) {
                return {
                    ...row,
                    amount: (amount < 1) ? 1 : amount,
                    total_price: !(amount < 1) ? parseFloat(row.variation.price) * amount : row.variation.price
                }
            }

            return row;
        });

        this.setState({
            form: {
                ...this.state.form,
                products,
            }
        });
    };

    updateOrderDetails = async () => {
        let response = await this.props.updateOrderDetails(
            this.props.orderId,
            this.state.form
        );

        if (response.errors && Object.keys(response.errors).length) {
            this.setState({errors: response.errors});
        } else {
            if (response.data && response.data.id) { //success
                this.setState({open: false});
                if (this.props.onSubmitRedirect) {
                    this.props.onSubmitRedirect(response)
                } else this.props.tableRef.current.onQueryChange();
            }
        }
    };

    validateAutocompleteSearchInput = (e, name) => {
        let value = e?.target.value;
        let { errors } = this.state;
        if (value && !/[а-я0-9]/i.test(e.target.value)) {
            this.setState({...this.state, errors: {[name]: ['Проверьте язык написания']}});
            return false;
        } else if (errors.hasOwnProperty(name)) {
            delete errors[name];
            this.setState({...this.state, errors: errors});
        }
        return true;
    };

    getProductByBarcode = async (barcode, is_main) => {
        const response = await this.props.getProductByBarcode(barcode);
        if (!response.status) {
            this.setState({
                ...this.state,
                errors: {[`barcode${is_main}`]: [response.message]}
            })
        } else if (response.status) {
            this.addProduct({...response.data, price: parseFloat(response.data.price), price_in: parseFloat(response.data.price_in)}, 1, is_main);
            this.setState({...this.state, barcode: {...this.state.barcode, [is_main]: ''}, errors: {}})
        }
    }

    clientSelected = async (client) => {
        if (!!!client) return
        const response = await this.props.findClientDeliveryDetails(client.id);
        let delivery_details_novaposhta = {};
        if (response.data) {
            delivery_details_novaposhta = {
                CityRecipient: response.data.CityRecipient,
                CityRecipientName: response.data.CityRecipientName,
                RecipientAddress: response.data.RecipientAddress,
                RecipientAddressName: response.data.RecipientAddressName,
                ServiceType: response.data.ServiceType,
            }
        }

        this.setState(merge(this.state, {
            form: {
                client_id: client.id,
                name: client.name,
                phone: client.phones[0].phone,
                email: client.email,
                comment: client.comment,
                delivery_details_novaposhta: {
                    ...this.state.form.delivery_details_novaposhta,
                    ...delivery_details_novaposhta,
                }
            }
        }))
    }

    priceGroupSelected = async (group_id) => {
        let form = {...this.state.form, price_group_id: group_id};

        let data = await this.props.getPriceGroupData(group_id);
        form.currency_id = data.data.currency.id;
        form.currency_course = data.data.currency.rate;
        form.currency = data.data.currency;
        this.setState(merge(this.state, {form: form}));
    }

    currencySelected = async (currency_id) => {
        let form = {...this.state.form, currency_id: currency_id};

        let data = await this.props.getCurrencyData(currency_id);
        form.currency_course = data.data.rate;
        form.currency = data.data;
        this.setState(merge(this.state, {form: form}));
    }

    productTableProps = (is_main) => {
        let { classes } = this.props;

        return {
            columns: [
                {
                    title: 'SKU',
                    field: 'variation.sku',
                    hideMobileTitle: true,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '20px 10px 10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>SKU</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{row.variation.sku}</Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Штрих-код',
                    field: 'variation.barcode',
                    headerProps: {style: {width: 140}},
                    hideMobileTitle: true,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Штрих-код</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{row.variation.barcode}</Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Товар',
                    field: 'title',
                    render: row => {
                        let productInfo = <>{row.variation.product.title} {row.variation.characteristic ? '(' + row.variation.characteristic.name + ')' : undefined}
                                            {row.comment ? <div><span style={{fontWeight: 'bold'}}>Комментарий:</span> {row.comment}</div> : undefined}</>;
                        return <Tooltip
                                    title={<span style={{ fontSize: '13px' }}>
                                           {productInfo}
                                        </span>}
                                    >
                                    <div style={{display: '-webkit-box', WebkitLineClamp: '3',  WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
                                        {productInfo}
                                    </div>
                            </Tooltip>
                    },
                    hideMobileTitle: true,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Товар</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>
                                {row.variation.product.title}
                                {row.variation.characteristic ? '(' + row.variation.characteristic.name + ')' : undefined}
                                {row.comment ? <div><span style={{fontWeight: 'bold'}}>Комментарий:</span> {row.comment}</div> : undefined}
                            </Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Кол-во',
                    field: 'amount',
                    headerProps: {style: {width: 70}},
                    render: row => <StandartInput
                        type={'number'}
                        min={1}
                        value={row.amount}
                        onChange={({target: {value}}) => this.setProductAmount(row.variation_id, parseInt(value), is_main)}
                        size={'small'}
                        variant={'outlined'}
                        fullWidth
                        className={clsx([classes.input, classes.tableInputFontSize, classes.resetInputMarginTop, classes.resetMarginBottom])}
                        margin={'normal'}
                    />,
                    hideMobileTitle: true,
                    mobileRender: (row, rowIndex) => <Grid container alignItems={'center'} style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Кол-во</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <StandartInput
                                type={'number'}
                                min={1}
                                value={row.amount}
                                onChange={({target: {value}}) => this.setProductAmount(row.variation_id, parseInt(value), is_main)}
                                size={'small'}
                                variant={'outlined'}
                                fullWidth
                                className={clsx([classes.input, classes.tableInputFontSize, classes.resetInputMarginTop, classes.resetMarginBottom])}
                                margin={'normal'}
                            />
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Цена закупки',
                    field: 'price_in',
                    hideMobileTitle: true,
                    render: row => <>{row.price_in ? parseFloat(row.price_in).toFixed(2) : '-'}</>,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Цена закупки</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{row.price_in ? parseFloat(row.price_in).toFixed(2) : '-'}</Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Цена продажи',
                    field: 'original_price',
                    hideMobileTitle: true,
                    render: row => <>{parseFloat(row.original_price).toFixed(2)}</>,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Цена продажи</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{parseFloat(row.original_price).toFixed(2)}</Typography>
                        </Grid>
                    </Grid>
                },
                {
                    title: 'Итого',
                    field: 'original_sum',
                    hideMobileTitle: true,
                    render: (row) => <>{parseFloat(row.original_sum).toFixed(2)}</>,
                    mobileRender: (row, rowIndex) => <Grid container style={{padding: '10px 10px 20px'}}>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>Итого</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant={'body2'}>{parseFloat(row.original_sum).toFixed(2)}</Typography>
                        </Grid>
                    </Grid>
                },
            ],
            actions: [
                {
                    icon: (row, index) => <AddProductModal
                        variation={row}
                        addProduct={(product, amount) => this.updateProduct(product, amount, is_main)}
                    />,
                    onClick: (e, row, index) => true
                },
                {
                    icon: (row, index) => <TooltipButton title="Удалить" icon={<DeleteOutlineOutlinedIcon />}
                    />,
                    onClick: (e, row, index) => this.removeProduct(row.variation_id, is_main)
                },
            ],
            customLastRow: (tableClasses) => (<ResponsiveComponent
                xs={<>
                    <Card variant="outlined">
                        <CardContent className={tableClasses.mobileRow} style={{marginBottom: '8px'}}>
                            <Grid container direction={'column'}>
                                <Grid item className={clsx([tableClasses.mobileCell, classes.lastRow_amountTitle])}>
                                    <Typography variant={'body2'}>Итого:</Typography>
                                </Grid>
                                <Grid item className={tableClasses.mobileCell}>
                                    <Grid container style={{padding: '20px 10px 10px'}}>
                                        <Grid item xs={6}>
                                            <Typography variant={'body2'}>Кол-во</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant={'body2'}>{ this.state.form.products.filter(product => product.is_main === is_main).reduce((accumulator, row) => accumulator + parseInt(row.amount), 0)}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item className={tableClasses.mobileCell}>
                                    <Grid container style={{padding: '10px 10px 20px'}}>
                                        <Grid item xs={6}>
                                            <Typography variant={'body2'}>Сумма</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant={'body2'}>
                                                {this.state.form.products.filter(product => product.is_main === is_main).reduce((accumulator, row) => accumulator + parseFloat(row.original_sum), 0).toFixed(2)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <AddProductModal
                        priceGroupId={this.state.form.price_group_id}
                        addProduct={(product, amount) => this.addProduct(product, amount, is_main)}
                    />

                    <InputBarcode
                        value={this.state.barcode[is_main]}
                        label="Штрих-код"
                        onChange={e => this.setState({barcode: {...this.state.barcode, [is_main]: e.target.value}})}
                        onBarcode={barcode => this.getProductByBarcode(barcode, is_main)}
                        name={'barcode' + is_main}
                        errors={this.state.errors}
                        variant={'outlined'}
                        size={'small'}
                        margin={'normal'}
                        fullWidth
                        className={classes.input}
                        InputProps={{
                            endAdornment:
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={e => this.getProductByBarcode(this.state.barcode, is_main)}
                                        style={{marginRight: '-14px'}}
                                    >
                                        <SendOutlinedIcon color={'primary'} />
                                    </IconButton>
                                </InputAdornment>,
                        }}
                    />
                </>}
                md={<TableRow>
                    <TableCell align={'center'} style={{ verticalAlign: 'middle' }}>
                        <AddProductModal
                            priceGroupId={this.state.form.price_group_id}
                            addProduct={(product, amount) => this.addProduct(product, amount, is_main)}
                        />
                    </TableCell>
                    <TableCell>
                        <InputBarcode
                            value={this.state.barcode[is_main]}
                            label="Штрих-код"
                            onChange={e => this.setState({barcode: {...this.state.barcode, [is_main]: e.target.value}})}
                            onBarcode={barcode => this.getProductByBarcode(barcode, is_main)}
                            name={'barcode' + is_main}
                            errors={this.state.errors}
                            variant={'outlined'}
                            size={'small'}
                            margin={'normal'}
                            fullWidth
                            className={clsx([classes.input, classes.tableInputFontSize, classes.resetInputMarginTop, classes.resetMarginBottom])}
                            InputProps={{
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={e => this.getProductByBarcode(this.state.barcode, is_main)}
                                            style={{marginRight: '-14px'}}
                                        >
                                            <SendOutlinedIcon color={'primary'} />
                                        </IconButton>
                                    </InputAdornment>,
                            }}
                        />
                    </TableCell>
                    <TableCell align={'right'} variant={'head'}>Итого:</TableCell>
                    <TableCell align={'right'} variant={'head'}>
                        {this.state.form.products.filter(product => product.is_main === is_main).reduce((accumulator, row) => accumulator + parseInt(row.amount), 0)}
                    </TableCell>
                    <TableCell></TableCell><TableCell></TableCell>
                    <TableCell align={'right'} variant={'head'}>
                        {this.state.form.products.filter(product => product.is_main === is_main).reduce((accumulator, row) => accumulator + parseFloat(row.original_sum), 0).toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                </TableRow>}
            />),
        }
    };

    renderPipelineFields = (pipelineId) => {
        const {classes, pipelines} = this.props;
        let selectedPipeline, pipeline_field;

        if (this.state.form.pipeline) {
            selectedPipeline = this.state.form.pipeline;
            pipeline_field = this.state.form.pipeline.fields;
        } else {
            selectedPipeline = pipelines.filter(pipeline => pipeline.id == pipelineId)[0];
            pipeline_field = selectedPipeline.pipeline_field;
        }

        if (selectedPipeline && pipeline_field.length !== 0) {
            return (<>
                <Grid item xs={12} className={classes.resetPaddingLeft_downMd}>
                    <FormLabel
                        component="legend"
                        className={clsx([classes.formLabel, classes.formLabel_marginTop, classes.formLabel_black])}
                    >Дополнительные поля</FormLabel>

                    <Grid container spacing={3} className={classes.utmSubContainer}>
                        {pipeline_field.map(field =>
                            <React.Fragment key={`pipeline_field_${field.id}`}>
                                {field.is_enabled
                                    ? <Grid item xs={12} md={6} lg={4}>
                                        {(() => {
                                            switch(field.type) {
                                                case orderFieldsTypes.field_input:
                                                    return <StandartInput
                                                        name={field.id}
                                                        value={this.state.form.pipeline_fields?.[field.id]}
                                                        errors={this.state.errors}
                                                        errorSubKey={'pipeline_fields'}
                                                        className={classes.input}
                                                        variant={'outlined'}
                                                        margin={'normal'}
                                                        size={'small'}
                                                        fullWidth
                                                        label={field.name}
                                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {pipeline_fields: {[field.id]: value}}}))}
                                                        required={!!field.required}
                                                    />
                                                case orderFieldsTypes.field_select:
                                                    return <Select
                                                        name={field.id}
                                                        value={this.state.form.pipeline_fields?.[field.id]}
                                                        errors={this.state.errors}
                                                        errorSubKey={'pipeline_fields'}
                                                        options={field.configuration.values.map((value) => {return {value: value, label: value}})}
                                                        displayEmpty={false}
                                                        label={field.name}
                                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {pipeline_fields: {[field.id]: value}}}))}
                                                        variant={'outlined'}
                                                        margin={'normal'}
                                                        size={'small'}
                                                        fullWidth
                                                        required={!!field.required}
                                                    />
                                                case orderFieldsTypes.field_textarea:
                                                    return <StandartInput
                                                        name={field.id}
                                                        value={this.state.form.pipeline_fields?.[field.id]}
                                                        errors={this.state.errors}
                                                        errorSubKey={'pipeline_fields'}
                                                        className={classes.input}
                                                        variant={'outlined'}
                                                        margin={'normal'}
                                                        size={'small'}
                                                        fullWidth
                                                        label={field.name}
                                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {pipeline_fields: {[field.id]: value}}}))}
                                                        multiline
                                                        rows={3}
                                                        required={!!field.required}
                                                    />
                                                // case orderFieldsTypes.field_file:
                                                //     return <>
                                                //         <input
                                                //             accept="image/*"
                                                //             style={{ display: 'none' }}
                                                //             id="raised-button-file"
                                                //             type="file"
                                                //             onChange={(e) => {
                                                //                 e.preventDefault();
                                                //                 let reader = new FileReader();
                                                //                 let file = e.target.files[0];
                                                //                 reader.onloadend = () => {
                                                //                     this.setState(
                                                //                         merge(this.state, {form: {pipeline_fields: {[field.id]: reader.result} }})
                                                //                         , () => this.setState({file: file}));
                                                //                 };
                                                //                 reader.readAsDataURL(file);
                                                //             }}
                                                //             name={`pipeline_fields_${field.id}`}
                                                //         />
                                                //         <label htmlFor="raised-button-file">
                                                //             <div
                                                //                 className={classes.image}
                                                //                 style={{backgroundImage: 'url(' + this.state.form.pipeline_fields[field.id] + ')'}}
                                                //             >{this.state.form.pipeline_fields[field.id] ? null : <span>Добавить фото</span>}</div>
                                                //         </label>
                                                //     </>
                                            }
                                        })(field)}
                                    </Grid>
                                    : null
                                }
                            </React.Fragment>
                        )}
                    </Grid>
                </Grid>
            </>)
        }

        return null;
    };

    render() {
        let { classes, context } = this.props;
        const {novaposhtaConfig} = this.state;
        let showNovaposhtaDeliveryDetailsForm = context.modules.novaposhta.enabled && !this.state.form.ttn;
        let showUkrposhtaDeliveryDetailsForm = context.modules.ukrposhta.enabled && !this.state.form.ttn;

        return (<>

            {this.state.open && <Helmet>
                <title>{`${this.props.orderId ? 'Редактирование заказа' : 'Создание заказа'} | BeClear CRM`}</title>
            </Helmet>}

            <SimpleDialog
                fullWidth={true}
                maxWidth={'lg'}
                open={this.state.open}
                dialogProps={{
                    onClick: e => e.stopPropagation(),
                    disableBackdropClick: true,
                }}
                onClose={(e) => {
                    this.setState({open: false})
                }}
                title={ this.props.orderId
                    ? <ResponsiveComponent xs='Редактирование заказа' sm='Редактирование существующего заказа'/>
                    : <ResponsiveComponent xs='Добавление заказа' sm='Добавление нового заказа'/> }
                icon={this.props.customOpenButton
                    ? <div onClick={e => this.setState({open : true})}>{this.props.customOpenButton}</div>
                    : this.props.orderId
                        ? <TooltipButton title="Редактировать"
                            icon={<EditOutlinedIcon color={'primary'} style={{marginLeft: 'auto'}} />}
                            onClick={(e) => this.setState({open: true})}
                        />
                        : <LabelButton
                            title={'Создать заказ'}
                            icon={<AddCircleRoundedIcon color={'primary'}/>}
                            onClick={(e) => this.setState({open: true})}
                            disableMargin
                        />
                }
                actions={[
                    (<Button
                        onClick={(e) => {
                            e.stopPropagation();
                            this.updateOrderDetails();
                        }}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                <Grid container spacing={3} className={classes.gridContainer}>
                    <Grid item xs={12} lg={3} className={classes.resetPaddingRight_downMd}>
                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_black])}
                        >Данные клиента</FormLabel>

                        <Grid container spacing={3} className={classes.gridSubContainer}>
                            <Grid item xs={12} md={6} lg={12}>
                                <StandartInput
                                    name={'name'}
                                    value={this.state.form.name}
                                    errors={this.state.errors}
                                    label="Покупатель"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {name: value}}))}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                />
                                <ClientPhoneAutocomplete
                                    name={'phone'}
                                    value={this.state.form.phone}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Телефон"
                                    onChange={(phone) => this.setState(merge(this.state,{form: {phone: phone}}))}
                                    clientSelected={this.clientSelected}
                                />
                                <StandartInput
                                    name={'email'}
                                    value={this.state.form.email}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Email"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {email: value}}))}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={12}>
                                <StandartInput
                                    name={'comment'}
                                    value={this.state.form.comment}
                                    errors={this.state.errors}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Комментарий"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {comment: value}}))}
                                />
                                <RemoteAutocompleteSelect
                                    name={'payment_type'}
                                    url={'/api/v1/autocomplete/payment-types'}
                                    value={this.state.form.payment_type}
                                    errors={this.state.errors}
                                    label="Способ оплаты"
                                    onChange={(e, {value}) => this.setState(merge(this.state, {form: {payment_type: value, amount_prepaid: 0}}))}
                                    disableClearable={true}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    // groupBy={(option) => option.group.name}
                                />
                                {this.state.form.payment_type === 'partial_prepaid' && <StandartInput
                                    type={'number'}
                                    name={'amount_prepaid'}
                                    value={this.state.form.amount_prepaid}
                                    errors={this.state.errors}
                                    errorSubKey={'amount_prepaid'}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                    label="Сумма частичной предоплаты"
                                    onChange={({target: {value}}) => this.setState(merge(this.state, {form: {amount_prepaid: value}}))}
                                />}
                            </Grid>

                            {this.props.orderId && <Grid item xs={12}>
                                <RemoteAutocompleteSelect
                                    url={'/api/v1/autocomplete/users'}
                                    name={'user_id'}
                                    value={this.state.form.user_id}
                                    errors={this.state.errors}
                                    label="Ответственный менеджер"
                                    onChange={(e, {value}) => this.setState({form: {...this.state.form, user_id: value}})}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                />
                            </Grid>}
                        </Grid>

                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_marginTop, classes.formLabel_black])}
                        >Доставка</FormLabel>

                        <Grid container spacing={3} className={classes.gridSubContainer}>
                            <Grid item xs={12} className={classes.delivery_row2}>
                                <div className={'delivery_row2_item'}>
                                    <RemoteAutocompleteSelect
                                        name={'ttn_type'}
                                        url={'/api/v1/autocomplete/delivery-services'}
                                        value={this.state.form.ttn_type}
                                        errors={this.state.errors}
                                        label="Способ доставки"
                                        onChange={(e, {value}) => this.setState(merge(this.state, {form: {ttn_type: value}}))}
                                        disableClearable={true}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                    />
                                </div>

                                <div className={'delivery_row2_item'}>
                                    <StandartInput
                                        name={'ttn'}
                                        value={this.state.form.ttn}
                                        errors={this.state.errors}
                                        label="ТТН"
                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {ttn: value}}))}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                    />
                                </div>
                            </Grid>

                            {showUkrposhtaDeliveryDetailsForm && this.state.form.ttn_type === 'ukrposhta' && <>
                                <Grid item xs={12} className={classes.delivery_row2}>
                                    <div className={'delivery_row2_item'}>
                                        <Select
                                          name={'ServiceType'}
                                          value={this.state.form.delivery_details_ukrposhta ? this.state.form.delivery_details_ukrposhta.deliveryType : UkrposhtaDeliveryTypes[0]}
                                          options={[UkrposhtaDeliveryTypes[0]]}
                                          displayEmpty={false}
                                          label="Технология доставки"
                                          onChange={({target: {value}}) => this.setState(merge(this.state,{form: {delivery_details_ukrposhta: {deliveryType: value}}}))}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                        />
                                    </div>

                                    <div className={'delivery_row2_item'}>
                                        <StandartInput
                                          name={'Description'}
                                          value={this.state.form.delivery_details_ukrposhta ? this.state.form.delivery_details_ukrposhta.description : ''}
                                          errors={this.state.errors}
                                          errorSubKey={'delivery_details_ukrposhta'}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                          label="Описание груза"
                                          onChange={({target: {value}}) => this.setState(merge(this.state, {form: {delivery_details_ukrposhta: {description: value}}}))}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12} className={classes.delivery_row2}>
                                    <div className={'delivery_row2_item'}>
                                        <RemoteAutocompleteWithSearch
                                          name={'recipient_address'}
                                          initOnRuntime
                                          initialValue={{
                                              value: this.state.form?.delivery_details_ukrposhta?.recipient_address,
                                              label: this.state.form?.delivery_details_ukrposhta?.recipient_address,
                                          }}
                                          url={`/api/v1/modules/ukrposhta/address/city`}
                                          searchFieldName={'FindByString'}
                                          value={this.state.form.delivery_details_ukrposhta ? this.state.form.delivery_details_ukrposhta.recipient_address : ''}
                                          errors={this.state.errors}
                                          errorSubKey={'delivery_details_ukrposhta'}
                                          label="Населенный пункт"
                                          onChange={(e, target) => this.setState(merge(this.state, {form: { delivery_details_ukrposhta: {recipient_address: target?.label}}}))}
                                          disableClearable={false}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                        />
                                    </div>
                                    <div className={'delivery_row2_item'}>
                                        <StandartInput
                                          name={'recipient_postcode'}
                                          value={this.state.form.delivery_details_ukrposhta ? this.state.form.delivery_details_ukrposhta.recipient_postcode : ''}
                                          errors={this.state.errors}
                                          errorSubKey={'delivery_details_ukrposhta'}
                                          className={classes.input}
                                          variant={'outlined'}
                                          margin={'normal'}
                                          size={'small'}
                                          fullWidth
                                          label="Индекс отделения"
                                          onChange={({target: {value}}) => this.setState(merge(this.state, {form: {delivery_details_ukrposhta: {recipient_postcode: value}}}))}
                                        />
                                    </div>
                                </Grid>
                            </>}

                            {showNovaposhtaDeliveryDetailsForm && this.state.form.ttn_type === 'novaposhta' && <>
                                <Grid item xs={12} className={classes.delivery_row2}>
                                    <div className={'delivery_row2_item'}>
                                        <Select
                                            name={'ServiceType'}
                                            value={this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.ServiceType : NovaposhtaDeliveryTypes[0]}
                                            options={[NovaposhtaDeliveryTypes[0]]}
                                            displayEmpty={false}
                                            label="Технология доставки"
                                            onChange={({target: {value}}) => this.setState(merge(this.state,{form: {delivery_details_novaposhta: {ServiceType: value}}}))}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                        />
                                    </div>

                                    <div className={'delivery_row2_item'}>
                                        <StandartInput
                                            name={'Description'}
                                            value={this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.Description : ''}
                                            errors={this.state.errors}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                            label="Описание груза"
                                            onChange={({target: {value}}) => this.setState(merge(this.state, {form: {delivery_details_novaposhta: {Description: value}}}))}
                                        />
                                    </div>
                                </Grid>

                                <Grid item xs={12} className={classes.delivery_row2}>
                                    <div className={'delivery_row2_item'}>
                                        <RemoteAutocompleteWithSearch
                                            name={'CityRecipient'}
                                            value={this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.CityRecipient : ''}
                                            errors={this.state.errors}
                                            errorSubKey={'delivery_details_novaposhta'}
                                            url={'/api/v1/modules/novaposhta/autocomplete/address/city?api_key=' + novaposhtaConfig.api_key}
                                            searchFieldName={'CityName'}
                                            label="Населенный пункт"
                                            onChange={(e, target) => this.setState(merge(
                                                this.state,
                                                {
                                                    form: {
                                                        delivery_details_novaposhta: {
                                                            CityRecipient: target?.value,
                                                            CityRecipientName: target?.label,
                                                            RecipientAddress: '',
                                                            RecipientAddressName: ''
                                                        }
                                                    }
                                                }
                                            ))}
                                            initOnRuntime
                                            initialValue={{
                                                value: this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.CityRecipient : null,
                                                label: this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.CityRecipientName : null,
                                            }}
                                            validateSearchInput={this.validateAutocompleteSearchInput}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                        />
                                    </div>

                                    <div className={'delivery_row2_item'}>
                                        <RemoteAutocompleteWithSearch
                                            name={'RecipientAddress'}
                                            initOnRuntime
                                            initialValue={{
                                                value: this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.RecipientAddress : null,
                                                label: this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.RecipientAddressName : null,
                                            }}
                                            url={this.state.form.delivery_details_novaposhta
                                                ? this.state.form.delivery_details_novaposhta.CityRecipient
                                                    ? '/api/v1/modules/novaposhta/autocomplete/address/warehouse?CityRef=' + this.state.form.delivery_details_novaposhta.CityRecipient + '&api_key=' + novaposhtaConfig.api_key
                                                    : ''
                                                : ''
                                            }
                                            searchFieldName={'FindByString'}
                                            value={this.state.form.delivery_details_novaposhta ? this.state.form.delivery_details_novaposhta.RecipientAddress : ''}
                                            errors={this.state.errors}
                                            label="Отделение"
                                            onChange={(e, target) => this.setState(merge(this.state, {form: {delivery_details_novaposhta: { RecipientAddress: target?.value, RecipientAddressName: target?.label}}}))}
                                            disableClearable={false}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                        />
                                    </div>
                                </Grid>
                            </>}
                        </Grid>
                    </Grid>

                    <Grid item item xs={12} lg={9} className={classes.resetPaddingLeft_downMd}>
                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_marginTop_downMd, classes.formLabel_black])}
                        >Основные товары</FormLabel>

                        <div className={classes.tableWrapper}>
                            <MaterialTableComponent
                                data={this.state.form.products.filter(product => product.is_main === 1)}
                                name={'products'}
                                errors={this.state.errors}
                                {...this.productTableProps(1)}
                            />
                        </div>

                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_marginTop, classes.formLabel_black])}
                        >Допродажа</FormLabel>

                        <div className={classes.tableWrapper}>
                            <MaterialTableComponent
                                data={this.state.form.products.filter(product => product.is_main === 0)}
                                {...this.productTableProps(0)}
                            />
                        </div>

                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_marginTop, classes.formLabel_black])}
                        >Настройки заказа</FormLabel>

                        <Grid container spacing={3} className={classes.gridSubContainer} direction={'column'}>
                            <Grid item xs={12} className={classes.resetPaddingLeft_downMd}>
                                <Grid container spacing={3} className={classes.utmSubContainer}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <RemoteAutocompleteSelect
                                            name={'currency_id'}
                                            url={'/api/v1/autocomplete/price-groups'}
                                            value={this.state.form.price_group_id}
                                            disabled={this.state.form.products.length > 0}
                                            errors={this.state.errors}
                                            label="Группа цен"
                                            onChange={(e, {value}) => this.priceGroupSelected(value)}
                                            disableClearable={true}
                                            variant={'outlined'}
                                            size={'small'}
                                            margin={'normal'}
                                            className={clsx([
                                                classes.input,
                                                classes.resetInputMarginTop,
                                            ])}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <RemoteAutocompleteSelect
                                            name={'currency_id'}
                                            url={'/api/v1/autocomplete/currencies'}
                                            value={this.state.form.currency_id}
                                            disabled={this.state.form.products.length > 0}
                                            errors={this.state.errors}
                                            label="Код валюты"
                                            onChange={(e, {value}) => this.currencySelected(value)}
                                            disableClearable={true}
                                            variant={'outlined'}
                                            size={'small'}
                                            margin={'normal'}
                                            className={clsx([
                                                classes.input,
                                                classes.resetInputMarginTop,
                                            ])}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <Input
                                            name={'currency_course'}
                                            value={this.state.form.currency_course}
                                            label={<ResponsiveComponent xs='Курс' sm='Курс валюты'/>}
                                            onChange={({target: {value}}) => this.setState(merge(this.state, {form: {currency_course: isNaN(parseFloat(value)) ? 0 : parseFloat(value)}}))}
                                            type="number"
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                        />
                                    </Grid>
                                    <PermissionModule
                                        name={'pipelines'}
                                    >
                                        <Grid item xs={12} md={6} lg={4}>
                                            <RemoteAutocompleteSelect
                                                url={'/api/v1/autocomplete/pipelines'}
                                                name={'pipeline_id'}
                                                value={this.state.form.pipeline_id}
                                                errors={this.state.errors}
                                                label="Пайплайн заказа"
                                                onChange={(e, newValue) => {
                                                    let pipeline_fields = {};
                                                    if (newValue) {
                                                        this.props.pipelines.filter(pipeline => pipeline.id == newValue.value)[0].pipeline_field.forEach(field => {
                                                            if (field.is_enabled) {
                                                                pipeline_fields[field.id] = field.default_value;
                                                            }
                                                        });
                                                    }
                                                    this.setState(merge(this.state, {form: {
                                                            pipeline_id: newValue ? newValue.value : null,
                                                            pipeline_fields: pipeline_fields,
                                                        }}))
                                                }}
                                                disableClearable={false}
                                                variant={'outlined'}
                                                size={'small'}
                                                margin={'normal'}
                                                disabled={this.props.orderId}
                                            />
                                        </Grid>
                                    </PermissionModule>
                                </Grid>
                            </Grid>

                            {this.state.form.pipeline_id && this.renderPipelineFields(this.state.form.pipeline_id)}
                        </Grid>

                        <FormLabel
                            component="legend"
                            className={clsx([classes.formLabel, classes.formLabel_marginTop, classes.formLabel_black, classes.formLabel_withIcon, classes.formLabel_cursorPointer])}
                            onClick={e => this.setState({...this.state, isMarketingPanelOpen: !this.state.isMarketingPanelOpen})}
                        >
                            Маркетинг
                            {this.state.isMarketingPanelOpen
                                ? <ArrowDropUpIcon />
                                : <ArrowDropDownIcon />
                            }
                        </FormLabel>
                        {this.state.isMarketingPanelOpen
                            ? <UtmTable
                                utm={this.state.form.utm}
                                errors={this.state.errors}
                                onChange={({target: {name, value}}) => this.setState(merge(this.state, {form: {utm: {[name]: value}}}))}
                                onSelectSource={(utm) => this.setState(merge(this.state, {form: {utm}}))}
                                isEditable={!this.props.orderId}
                            />
                            : null
                        }

                    </Grid>
                </Grid>
            </SimpleDialog>
        </>
        );
    }
}
